import type {TextProps} from "@/styles/text.types";
import {css} from "styled-components";
import theme from "@/styles/theme";

const fontSizes = {
    small: theme.fontSize.small,
    medium: theme.fontSize.medium,
    default: theme.fontSize.default,
    large: theme.fontSize.large
};

const textColors = {
    default: theme.text.default,
    muted: theme.text.muted,
    mutedExtra: theme.text.mutedExtra,
    primary: theme.text.primary,
    warning: theme.text.warning,
    emphasis: theme.text.emphasis,
    selection: theme.text.selection,
    invert: theme.text.invert
};

export const text = (
    {
        textAlign,
        textSize,
        textColor,
        textDecoration,
        textWrap,
        textWeight
    }: TextProps) => {
    return css`
        ${textAlign && css`text-align: ${textAlign};`}
        ${textSize && css`font-size: ${fontSizes[textSize]}px;`}
        ${textColor && css`color: ${textColors[textColor]}`}
        ${textDecoration && css`text-decoration: ${textDecoration}`}
        ${textWrap && css`white-space: ${textWrap}`}
        ${textWeight && css`font-weight: ${textWeight}`}
    `;
};
